import { View, Text, StyleSheet } from "@react-pdf/renderer";
import React, { Fragment } from "react";

const TripDetailsList = ({ data }) => {
  const styles = StyleSheet.create({
    container: {
      width: "100%",
      flexDirection: "row",
      paddingLeft: "15px",
      marginTop: 15,
      marginBottom: 25,
    },
    subContiner: {
      width: "50%",
    },
    dataContainer: {
      width: "100%",
      flexDirection: "row",
    },
    title: {
      width: "40%",
      color: "#00000099",
      opacity: 0.5,
      fontSize: "11px",
      fontWeight: "500",
      marginBottom: "5px",
    },
    list: {
      width: "60%",
      color: "#141414F4",
      fontSize: "11px",
      fontStyle: "bold",
    },
  });
  let fromDate = data?.from_date ? data?.from_date.split(",")?.[0] : null;
  let toDate = data?.to_date ? data?.to_date.split(",")?.[0] : null;
  return (
    <Fragment>
      <View style={styles.container}>
        <View style={styles.subContiner}>
          <View style={styles.dataContainer}>
            <Text style={styles.title}>Submitted By</Text>
            <Text style={styles.list}>
              {data?.submitted_by ? data?.submitted_by : "-"}
            </Text>
          </View>
          <View style={styles.dataContainer}>
            <Text style={styles.title}>Submitted On</Text>
            <Text style={styles.list}>
              {data?.submitted_on ? data?.submitted_on : "-"}
            </Text>
          </View>
          <View style={styles.dataContainer}>
            <Text style={styles.title}>Report Duration</Text>
            <Text style={styles.list}>{`${fromDate ? fromDate : ""} - ${
              toDate ? toDate : ""
            }`}</Text>
          </View>
        </View>
        <View style={styles.subContiner}>
          <View style={styles.dataContainer}>
            <Text style={styles.title}>Submitted To</Text>
            <Text style={styles.list}>
              {data?.submitted_to ? data?.submitted_to : "-"}
            </Text>
          </View>
          <View style={styles.dataContainer}>
            <Text style={styles.title}>Status</Text>
            <Text style={styles.list}>{data?.status ? data?.status : "-"}</Text>
          </View>
        </View>
      </View>
    </Fragment>
  );
};

export default TripDetailsList;
